import React from 'react';
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import {Icon, SvgIcon} from "@mui/material";
import {lightBlue} from "@mui/material/colors";
import {useSelector} from "react-redux";
import {format, parse} from "date-fns";
import {ReactComponent as Calendar} from '../../../../svg/Blue/Calendar.svg';
import {ReactComponent as DayAndNight} from '../../../../svg/Blue/Day-and-Night.svg';
import {ReactComponent as Boat} from '../../../../svg/Blue/Boat.svg';
import {ReactComponent as Tent} from '../../../../svg/Blue/Tent.svg';


// const imgTrip = "https://placehold.it/1920x540/?text=Trip1";
const TripHead = () => {
    const {data: trip} = useSelector(state => state.trip);
    const heroImg = trip.hero_path || trip.trip_class_info?.headerImage;

    const boardDate = parse(trip['boarddate'], 'yyyy-MM-d', new Date());
    const returnDate = parse(trip['returndate'], 'yyyy-MM-d', new Date());
    const tripDates = `${format(boardDate, 'MMM d')} - ${format(returnDate, 'MMM d')}, ${format(returnDate, 'yyyy')}`;

    return (
        <div>
            <Container className="tripContainer">
                <div style={{
                    backgroundImage: `url("${heroImg}")`,
                    backgroundPositionY: trip['tripClassName'] === 'San Ignacio Lagoon' ? 'bottom' : 'center'
                }} className={'mainImage'}/>
                <div className="tripInfo">
                    <Grid container spacing={3} justify="space-between">
                        <Grid item xs>
                            <Typography component="h3" variant="h4" align="center">
                                <span style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                    <SvgIcon component={Calendar} viewBox="0 0 50 50" sx={{
                                        stroke: lightBlue[500],
                                        fill: lightBlue[500],
                                        width: '35px',
                                        height: '30px',
                                        marginRight:'10px'
                                    }}/>
                                    {tripDates}
                                </span>
                            </Typography>
                        </Grid>
                        <Grid item xs>
                            <Typography component="h3" variant="h4" align="center">
                                <span style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                    <SvgIcon component={DayAndNight} viewBox="0 0 50 50" sx={{
                                        stroke: lightBlue[500],
                                        fill: lightBlue[500],
                                        width: '35px',
                                        height: '30px',
                                        marginRight:'10px'
                                    }}/>
                                    {trip.length} nights {parseInt(trip.length) + 1} days
                                </span>
                            </Typography>
                        </Grid>
                        <Grid item xs>
                            <Typography component="h3" variant="h4" align="center">
                                <span style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                    {trip.tripClass !== 'San Ignacio Lagoon' ?
                                        <SvgIcon component={Boat} viewBox="0 0 50 50" sx={{
                                            stroke: lightBlue[500],
                                            fill: lightBlue[500],
                                            width: '35px',
                                            height: '30px',
                                            marginRight:'10px'
                                        }}/> : <SvgIcon component={Tent} viewBox="0 0 50 50" sx={{
                                            stroke: lightBlue[500],
                                            fill: lightBlue[500],
                                            width: '35px',
                                            height: '30px',
                                            marginRight:'10px'
                                        }}/>
                                    }
                                    {trip?.location?.location}
                                </span>
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
            </Container>
        </div>
    );
};

export default TripHead;
